/**
 *
 * 套餐数据，处方判定
 * @param {*} param0
 * @returns
 */
import sphCylInRange from "./sphCylInRange";

import { create } from "@/src/models/basket";
import { getPackageUsage } from "@/src/utils/lensComponents/lensBar/addCart";
import { IProps } from "@/src/productDetails/ProductPackage/ProductPackageItem";
import {
    IInitedInfo,
    IProductDetailsInfo,
} from "@/store/modules/productDetails";

export const checkProductPackageRx = ({
    rx,
    rxStr,
    packageInfo,
    productInfo,
    color_id,
    page_id,
    isDecentered,
}: {
    rx: any;
    rxStr: any;
    packageInfo: Partial<IProps["data"]>;
    productInfo: Partial<IInitedInfo & IProductDetailsInfo>;
    color_id: number | undefined;
    page_id: number | null;
    isDecentered: any;
}): Promise<void> => {
    return new Promise(async (resolve, rejects) => {
        if (!rx || !packageInfo) {
            console.log("套餐添加失败：无处方");
            return rejects();
        }

        const { master_categories_id, products_id } = productInfo;
        const { packageParseTag, packageCategoryId } = packageInfo;

        let usageDetail = packageParseTag
            ? packageParseTag.toLowerCase()
            : "distance";

        switch (usageDetail) {
            case "progressive":
                usageDetail = "standardPL";
                break;
            case "advanced progressive":
                usageDetail = "advancedPL";
                break;
            default:
                break;
        }
        // 联合光度筛选
        const {
            notShowProgressiveNoLine,
            notShowBifocalWithLine,
            notShowPolarized,
        } = sphCylInRange({
            ...rx,
            glassType: master_categories_id,
            usageDetail,
        });
        if (packageCategoryId == 6 && notShowPolarized) {
            console.log("套餐添加失败：notShowPolarized");
            return rejects();
        }
        if (usageDetail === "bifocal" && notShowBifocalWithLine) {
            console.log("套餐添加失败：notShowBifocalWithLine");
            return rejects();
        }

        if (
            (usageDetail === "advancedPL" || usageDetail === "standardPL") &&
            notShowProgressiveNoLine
        ) {
            console.log("套餐添加失败：notShowProgressiveNoLine");
            return rejects();
        }

        //根据处方获取相关参数
        let ids = getPackageUsage({
            rx: rxStr,
            isDecentered,
            usage: { name: usageDetail },
        });

        let param = {
            color_id,
            product_id: products_id,
            page_id: page_id,
            package_id: packageInfo.id,
            quantity: 1,
            ...ids,
        };

        await create(param);

        return resolve();
    });
};
